import React, { Fragment } from "react";
import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactSection from "../../components/ContactSection";
import Mcc from "../../components/mcc/Mcc";
import Facebook from "../../components/Socials/Facebook";
import Youtube from "../../components/Socials/Youtube";

const HolbooBarihPage = ({ isDark, onToggleDark }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle
            pageTitle={"Бидэнтэй холбогдох"}
            pagesub={"Холбогдох"}
            tolink={"#bidentei-holbogodoh"}
          />
          <div className="container" id="bidentei-holbogodoh">
            <div className="row">
              <div className="col-lg-10 mx-auto pt-70">
                <Mcc />
                <div className="aboutDetails text-center">
                  <p className="aboutDetailsText mb-20">
                    "Монгол Сувд Сүм" нь хүн бүрийн зүрхэнд гэрэл асаах итгэл,
                    урам, ухаарлын үгсийг түгээж, нийгэмд сайн сайхныг
                    дэлгэрүүлэх үйл хэрэгт тууштай зүтгэсээр байна. Бидний хийж
                    буй ажлууд халуун сэтгэлийн тусламж, ухаарал өгөх
                    сургалтууд, эв нэгдлийг эрхэмлэсэн уулзалтууд - энэ нийгмийг
                    илүү гэрэлтэй, илүү хүнлэг болгох өчүүхэн боловч үнэт хувь
                    нэмэр гэж итгэдэг.
                  </p>
                  <p className="aboutDetailsText mb-20">
                    Энэхүү товхимолд багтсан үйл явдлууд бол бидний итгэл
                    үнэмшлийн тусгал, сэтгэлийн урсгал билээ. Цаашид ч "Монгол
                    Сувд Сүм" нь нийгмийн сайн сайхны төлөөх үйлсэд олон
                    түмэнтэйгээ хамтран, хайр, итгэл, энэрэлд тулгуурласан
                    замаар урагшлан алхах болно.
                  </p>
                  <p className="aboutDetailsText mb-20">
                    <strong>ГЭРЭЛ ТҮГЭЭЖ, САЙН САЙХНЫГ ДЭЛГЭРҮҮЛЦГЭЭЕ.</strong>
                  </p>
                </div>
                <div className="contactInfo text-center pt-30 pb-20">
                  <div className="col-12 pb-20">
                    <hr className="footer__line" />
                  </div>
                  <ul className="busadHayg pt-10 pb-30">
                    <li>
                      <span className="col-lg-4">
                        <i className="fa-solid fa-location-dot pb-10"></i>
                        Монгол улс, Улаанбаатар, Баянгол дүүрэг, 9-р хороо, 3-р
                        хороолол, Ард Аюушийн өргөн чөлөө, 75 тоот
                      </span>
                      <span className="col-lg-4">
                        <a
                          href="mailto:mongol.suvd.church@gmail.com"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            color: "inherit",
                          }}
                        >
                          <i className="fa-solid fa-envelope pb-10"></i>
                          mongol.suvd.church@gmail.com
                        </a>
                      </span>
                      <span className="col-lg-4">
                        <i className="fa-solid fa-phone-volume pb-10"></i>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}
                          >
                            +976
                          </p>
                          <p>
                            <a
                              href="tel:99724328"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              99724328
                            </a>
                          </p>
                          <p>
                            <a
                              href="tel:89707789"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              90004328
                            </a>
                          </p>
                        </div>
                      </span>
                    </li>
                  </ul>
                  <div className="col-12 pb-20">
                    <hr className="footer__line" />
                  </div>
                  <div className="socialHayg__header">Бидний сошиал хаяг</div>
                  <ul className="socialHayg">
                    <Facebook ClickHandler={ClickHandler} />
                    {/* <a
                      onClick={ClickHandler}
                      className="facebook"
                      href="https://www.facebook.com/mongolsuvdchurch"
                      rel="nofollow noreferrer"
                      target="_blank"
                    >
                      <li>
                        <i className="fab fa-facebook-f"></i>
                      </li>
                    </a> */}
                    {/* <a
                      onClick={ClickHandler}
                      className="instagram"
                      href="/"
                      rel="nofollow noreferrer"
                      target="_blank"
                    >
                      <li>
                        <i className="fab fa-instagram"></i>
                      </li>
                    </a>
                    <a
                      onClick={ClickHandler}
                      className="telegram"
                      href="/"
                      rel="nofollow noreferrer"
                      target="_blank"
                    >
                      <li>
                        <i className="fab fa-telegram"></i>
                      </li>
                    </a> */}
                    <Youtube showI ClickHandler={ClickHandler} />
                    {/* <a
                      onClick={ClickHandler}
                      className="youtube"
                      href="https://www.youtube.com/@biblenom"
                      rel="nofollow noreferrer"
                      target="_blank"
                    >
                      <li>
                        <i className="fab fa-youtube"></i>
                      </li>
                    </a> */}
                  </ul>
                </div>
                <Mcc />
              </div>
            </div>
          </div>
          <ContactSection />
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default HolbooBarihPage;
